import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/HomePage.vue'
import About from './pages/AboutPage.vue'
import Product from './pages/ProductPage.vue'
import News from './pages/NewsPage.vue'
import Partner from './pages/PartnerPage.vue'
import ContactUs from './pages/ContactUsPage.vue'
import Hire from './pages/HirePage.vue'
import Forum from './pages/ForumPage.vue'



Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'HomePage',
    component: Home
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: About
  },
  {
    path: '/product',
    name: 'ProductPage',
    component: Product
  },
  {
    path: '/news',
    name: 'NewsPage',
    component: News

  },
  {
    path: '/partner',
    name: 'PartnerPage',
    component: Partner

  },
  {
    path: '/contactus',
    name: 'ContactUsPage',
    component: ContactUs

  },
  {
    path: '/news/:id', // 使用动态参数接收ID
    name: 'NewsDetail', // 路由名称
    component: () => import('./pages/NewsDetail.vue') // 按需加载组件
  },
  {
    path: '/hire',
    name: 'HirePage',
    component: Hire

  },
  {
    path: '/Forum',
    name: 'ForumPage',
    component: Forum

  }

]

const router = new VueRouter({
  routes
})

export default router